import getSettings from './utils/getSettings';

export default getSettings();



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/settings.js
 **/